/**
 * Original Author: Joseph Moore
 * Original Team: Area 51
 */
export default {
  computed: {
    rules() {
      const rules = [];

      if (this.schema.validation) {
        const regexRules = this.schema.validation.map(({ regex, error }) => {
          const [, cleaned] = regex.match(/^(?:\/)?(.*?)(?:\/)?$/);
          // The AEM service handles the 'required' flag by
          // adding a rule with a certain regex and a message.
          // We'll detect that and add a simpler rule.
          if (isRequiredRegex(regex)) {
            return requiredRule(error);
          }
          const parsedRegex = new RegExp(cleaned);
          return (value) => !value || parsedRegex.test(value) || error;
        });
        rules.push(...regexRules);
      }
      return rules;
    },
    requiredErrorMessage() {
      const validation = this.schema.validation || [];
      const found = validation.find((rule) => isRequiredRegex(rule.regex));
      if (found) {
        return found.error;
      } else {
        return undefined;
      }
    },
  },
};

function requiredRule(text) {
  return function requiredRuleImpl(value) {
    return Boolean(value) || text;
  };
}

function isRequiredRegex(regex) {
  return regex === '/^[^]+$/';
}
